/* global Tena */
/* eslint max-lines: ["error", 600], complexity: ["error", 37] */

(function($) {
    'use strict';
    var Form = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$fields = this.$el.find('.form-field');
        this.originalValues = this.$el.serialize();
        this.originalValuesArray = this.$el.serializeArray();
        // If set to true when form is submitted, bypass validation
        this.bypassValidation = false;
        this.supportsPlaceholders =
            document.createElement('input').placeholder !== undefined;
        this.init();
    };
    Form.prototype = {
        iconValid: 'icon-validation-tick',
        iconInvalid: 'icon-validation-cross',
        init: function() {
            this.bindEvents();
            this.$fields.filter('.field-textarea').css('overflow', 'hidden').autogrow();
            this.loadScrollPosition();
        },
        bindEvents: function() {
            var that = this;
            that.$el.on('submit', function() {
                if (that.bypassValidation) {
                    return true;
                }
                that.bypassValidation = false;

                return that.validateForm();
            });
            // Validate field on change
            that.$el.find('input, textarea, select').on('change blur', function() {
                var $formField = $(this).closest('.form-field');
                that.validateField($formField);
            });
            if (!Tena.browser.ie7) {
                that.$el.find('.field-select').selectOrDie();
                // Reload select or die in forms inside tabs
                $(window).on('tabs.changed, accordion.changed', function(e, data) {
                    var $selects = data.show.find('.field-select');
                    $selects.selectOrDie('destroy').selectOrDie();
                });
            }
            var $passwordStrengthFields = that.$el.find('.field-password-strength');
            $passwordStrengthFields.each(function() {
                var $passwordStrengthField = $(this),
                    $passwordField = $(
                        '[name="' + $passwordStrengthField.data('password-field') + '"]'
                    );
                that.checkStrength($passwordField, $passwordStrengthField);
                $passwordField.keyup(function() {
                    that.checkStrength($passwordField, $passwordStrengthField);
                });
            });
            that.$el.on('change', function() {
                that.changed();
            });
            that.$el.on('change', 'input:radio', function() {
                // Show or hide elements based on radio button state
                $('input[id$=hdnSampleId]').val($(this).context.defaultValue);
                that.toggleShowIfCheckedElements();
            });
            that.$el.on('change', 'input:checkbox', function() {
                // Show or hide elements based on radio button state
                $('input[id$=hdnSampleId]').val($(this).context.defaultValue);
                that.toggleShowIfCheckedElements();
            });
            // Let select with .form-inline-action post the form without validation
            // Set selected value to a hidden field to be read by backend
            that.$el.on('change', '.form-inline-action', function() {
                var $field = $(this),
                    $hiddenField = $field.find('input[type="hidden"]');
                $hiddenField.val($field.find('select').val());
                that.bypassValidation = true;
                that.saveScrollPosition();
                that.$el.submit();
            });
            // Let button with .form-inline-action post the form without validation
            that.$el.on('click', 'button.form-inline-action', function() {
                that.bypassValidation = true;
                that.saveScrollPosition();
            });
            that.$el.find('[data-form-activate-on-change]').on('change', function() {
                var $field = $(this),
                    activate = $field.data('form-activate-on-change'),
                    $activate = $(activate);
                if ($activate.size() > 0) {
                    if (that.hasFieldBeenUpdated($field) && $field.val() !== '') {
                        that.activateElement($activate);
                        $('input[id$=hdnSampleId]').val($(this).context.defaultValue);
                    } else {
                        that.deactivateElement($activate);
                    }
                }
            });
            that.$el
                .filter('[data-activate-on-valid]')
                .on('change blur', ':input', function() {
                    var activate = that.$el.data('activate-on-valid'),
                        $activate = $(activate);
                    if (that.$el.find('.valid').size() === that.$fields.size()) {
                        that.activateElement($activate);
                    } else {
                        that.deactivateElement($activate);
                    }
                });
            that.$el
                .filter('[data-activate-on-valid]')
                .on('change blur', ':input', function() {
                    var activate = that.$el.data('activate-on-valid'),
                        $activate = $(activate);
                    if (that.$el.find('.valid').size() === that.$fields.size()) {
                        that.activateElement($activate);
                    } else {
                        that.deactivateElement($activate);
                    }
                });
            // Toggle password field visibility
            that.$el.on('change', '[data-toggle-password]', function() {
                var $this = $(this),
                    $input = $this.find('input'),
                    type = $input.is(':checked') ? 'text' : 'password',
                    targets = $this.data('toggle-password').split(',');
                $.each(targets, function() {
                    var $target = $('[name="' + this + '"');
                    $target.prop('type', type);
                });
            });
            that.$el.on('click', '.delete-row', function() {
                var $row = $(this).closest('tr');
                that.toggleRowDeleted($row);

                return false;
            });
            // Placeholder fallback
            if (!this.supportsPlaceholders) {
                var $placeholderFields = this.$fields.find('[placeholder]');
                $placeholderFields.each(function() {
                    var $field = $(this),
                        placeholder = $(this).attr('placeholder');
                    if (this.value.length === 0) {
                        this.value = placeholder;
                    }
                    $field
                        .on('focus', function() {
                            if (this.value === placeholder) {
                                this.value = '';
                            }
                        })
                        .on('blur', function() {
                            if ($.trim(this.value).length === 0) {
                                this.value = placeholder;
                            }
                        });
                });
            }
        },
        changed: function() {
            var that = this,
                $stateButtons = that.$fields.find('.btn-form-change-active'),
                newValues = that.$el.serialize();
            if (newValues === that.originalValues) {
                $stateButtons.addClass('btn-inactive').prop('disabled', true);
            } else {
                $stateButtons.removeClass('btn-inactive').prop('disabled', false);
            }
        },
        trimField: function($field) {
            if ($field.context && typeof $field.context.value === 'string') {
                $field.context.value = $field.context.value.replace(/</g, '');
                $field.context.value = $field.context.value.replace(/>/g, '');
            }
        },
        hasFieldBeenUpdated: function($field) {
            var that = this,
                name = $field.attr('name'),
                newValue = $field.val(),
                updated = false,
                found = false;
            $.each(that.originalValuesArray, function() {
                if (this.name === name) {
                    found = true;
                    if (this.value !== newValue) {
                        updated = true;
                    }
                }
            });
            if (!found) {
                updated = true;
            }

            return updated;
        },
        activateElement: function($el) {
            var classesToRemove = 'btn-inactive';
            if ($el.prop('disabled')) {
                $el.data('original-classes', $el.attr('class'));
                $el.removeClass(classesToRemove).prop('disabled', false);
            }
        },
        hasEMojiFreeCharacters: function(fieldValue) {
            var validFieldEMoji = true;
            var expr = new RegExp(
                /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g
            );

            if (
                window.environment.eMojiRegxExpression !== '' &&
                window.environment.eMojiRegxExpression !== undefined
            ) {
                expr = new RegExp(window.environment.eMojiRegxExpression);
            }
            if (expr.test(fieldValue)) {
                validFieldEMoji = false;
            }

            return validFieldEMoji;
        },
        deactivateElement: function($el) {
            $el.addClass($el.data('original-classes')).prop('disabled', true);
        },
        validateForm: function() {
            var that = this,
                $formField,
                validForm = true,
                validField;
            that.$fields.each(function() {
                $formField = $(this);
                validField = that.validateField($formField);
                if (!validField) {
                    validForm = false;
                }
            });

            return validForm;
        },
        validateField: function($formField) {
            var that = this,
                $field = $formField.find('.field'),
                fieldType = $field.prop('tagName'),
                validField = true,
                isEMojiFree = true,
                bypass = that.bypass($formField);
            $('<i>').addClass(that.iconValid);
            $('<i>').addClass(that.iconInvalid);
            that.trimField($field);
            $formField.find('.validate-message').hide();
            $formField.find('.' + that.iconValid).remove();
            $formField.find('.' + that.iconInvalid).remove();
            $formField.find('.invalid').removeClass('invalid');
            if (bypass) {
                return true;
            }
            if (!fieldType || fieldType === '') {
                fieldType = 'none';
            } else {
                fieldType = fieldType.toLowerCase();
            }
            if (
                $field.closest('.validate').length === 0 &&
                !$field.is('.field-radio') &&
                !$field.is('.field-checkbox')
            ) {
                if ($field.is('select') && $field.parent().is('.sod_select')) {
                    $field
                        .closest('.sod_select')
                        .wrap($('<div>').addClass('validate validate-' + fieldType));
                } else {
                    $field.wrap($('<div>').addClass('validate validate-' + fieldType));
                }
            }
            $field.closest('.validate').removeClass('invalid valid');
            if (!that.supportsPlaceholders && $field.is('[placeholder]')) {
                if ($field.val() === $field.attr('placeholder')) {
                    $field.val('');
                }
            }
            if ($formField.is('.validate-required')) {
                if ($field.is('.field-radio')) {
                    // Radio buttons
                    var found = false;
                    $formField.find('input').each(function() {
                        if ($(this).is(':checked')) {
                            found = true;
                        }
                    });
                    if (!found) {
                        validField = false;
                    }
                    // } else if($field.is('.field-checkbox') && !$field.prop('checked')) { // Checkbox
                    // 	validField = false;
                } else if ($field.is('.field-checkbox')) {
                    // Checkbox
                    validField = false;
                    $field.each(function() {
                        if ($(this).prop('checked')) {
                            validField = true;
                        }
                    });
                } else if ($.trim($field.val()).length > 0) {
                    // Default
                    isEMojiFree = that.hasEMojiFreeCharacters($field.val());
                    validField = isEMojiFree;
                } else {
                    validField = false;
                }
                if (validField) {
                    $field
                        .closest('.validate')
                        .addClass('valid')
                        .append($('<i>').addClass(that.iconValid));
                } else {
                    if (isEMojiFree === true) {
                        $formField.find('.validate-message-required').show();
                    } else {
                        $formField.find('.validate-message-invalid-input').show();
                    }
                    $field
                        .closest('.validate')
                        .addClass('invalid')
                        .append($('<i>').addClass(that.iconInvalid));
                }
            } else {
                isEMojiFree = that.hasEMojiFreeCharacters($field.val());
                if (isEMojiFree) {
                    $field
                        .closest('.validate')
                        .addClass('valid')
                        .append($('<i>').addClass(that.iconValid));
                } else {
                    $formField.find('.validate-message-invalid-input').show();

                    $field
                        .closest('.validate')
                        .addClass('invalid')
                        .append($('<i>').addClass(that.iconInvalid));
                }
            }
            if (validField && $formField.is('.validate-email')) {
                var expr = /^\w+([-.]?\w+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                if (!expr.test($field.val())) {
                    validField = false;
                    $formField.find('.validate-message-email').show();
                    $field
                        .closest('.validate')
                        .addClass('invalid')
                        .append($('<i>').addClass(that.iconInvalid));
                }
            }
            if (validField && $formField.is('.validate-match')) {
                var $matchesMessage = that.$el.find('.field-password-matches'),
                    $match = $('[name="' + $formField.data('match') + '"]');
                if ($match.val() === $field.val()) {
                    $matchesMessage.removeClass('hide');
                    validField = true;
                } else {
                    validField = false;
                    $formField.find('.validate-message-match').show();
                    $matchesMessage.addClass('hide');
                    $field
                        .closest('.validate')
                        .addClass('invalid')
                        .append($('<i>').addClass(that.iconInvalid));
                }
            }
            if (validField && $formField.is('.validate-length')) {
                var $lengthMessageMin = $formField.find('.validate-message-length-min'),
                    $lengthMessageMax = $formField.find('.validate-message-length-max'),
                    $min = $formField.data('min'),
                    $max = $formField.data('max');
                if ($field.val().length < $min) {
                    validField = false;
                    $lengthMessageMax.hide();
                    $lengthMessageMin.show();
                    if (!$field.closest('.validate').hasClass('invalid')) {
                        $field
                            .closest('.validate')
                            .addClass('invalid')
                            .append($('<i>').addClass(that.iconInvalid));
                    }
                } else if ($field.val().length > $max) {
                    validField = false;
                    $lengthMessageMin.hide();
                    $lengthMessageMax.show();
                    if (!$field.closest('.validate').hasClass('invalid')) {
                        $field
                            .closest('.validate')
                            .addClass('invalid')
                            .append($('<i>').addClass(that.iconInvalid));
                    }
                } else {
                    $lengthMessageMax.hide();
                    $lengthMessageMin.hide();
                    $field
                        .closest('.validate')
                        .addClass('valid')
                        .append($('<i>').addClass(that.iconValid));
                }
            }
            if (validField && $formField.is('.validate-number')) {
                var $numericMessage = $formField.find('.validate-message-numeric'),
                    regex = new RegExp(/^[0-9]+$/);
                if ($field.val().length && !regex.test($field.val())) {
                    validField = false;
                    $numericMessage.show();
                    if (!$field.closest('.validate').hasClass('invalid')) {
                        $field
                            .closest('.validate')
                            .addClass('invalid')
                            .append($('<i>').addClass(that.iconInvalid));
                    }
                } else {
                    $numericMessage.hide();
                    $field
                        .closest('.validate')
                        .addClass('valid')
                        .append($('<i>').addClass(that.iconValid));
                }
            }

            return validField;
        },
        checkStrength: function($field, $strength) {
            var $strengthSpan = $strength.find('span.strength'),
                numUpper = 0,
                numLower = 0,
                numNumber = 0,
                numSpecial = 0,
                value = $field.val();
            numUpper = value.match(/[A-Z]{1}/g);
            numLower = value.match(/[a-z]{1}/g);
            numNumber = value.match(/[0-9]{1}/g);
            numSpecial = value.match(/[[\]^$.|?*+()\\~`!@#%&\-_+={}'""<>:;, ]{1}/g);
            numUpper = numUpper ? numUpper.length : 0;
            numLower = numLower ? numLower.length : 0;
            numNumber = numNumber ? numNumber.length : 0;
            numSpecial = numSpecial ? numSpecial.length : 0;
            if (numUpper >= 2 && numLower >= 2 && numNumber >= 2 && numSpecial >= 2) {
                $strengthSpan
                    .removeClass('medium')
                    .removeClass('weak')
                    .addClass('strong')
                    .html('Very good');
            } else if (
                numUpper >= 2 &&
                numLower >= 2 &&
                (numNumber >= 2 || numSpecial >= 2)
            ) {
                $strengthSpan
                    .removeClass('strong')
                    .removeClass('weak')
                    .addClass('medium')
                    .html('Good');
            } else if (
                value.length >= 4 &&
                (numUpper >= 2 || numLower >= 2) &&
                (numNumber >= 1 || numSpecial >= 1)
            ) {
                $strengthSpan
                    .removeClass('strong')
                    .removeClass('weak')
                    .addClass('medium')
                    .html('Medium');
            } else {
                $strengthSpan
                    .removeClass('medium')
                    .removeClass('strong')
                    .addClass('weak')
                    .html('Low');
            }
        },
        bypass: function($formField) {
            var selectors = $formField.data('bypass'),
                $field = $formField.find('.field'),
                bypass = false,
                $bypass,
                $that,
                type,
                $match;
            // Do not bypass if a value is set
            if ($field.val()) {
                return false;
            }
            // Do not bypass if the matching field has a value
            if ($formField.is('.validate-match')) {
                $match = $('[name="' + $formField.data('match') + '"]');
                if ($match.val() !== $field.val()) {
                    return false;
                }
            }
            if (selectors) {
                $bypass = $(selectors);
                $bypass.each(function() {
                    $that = $(this);
                    type = $that.attr('type');
                    switch (type) {
                        case 'checkbox':
                        case 'radio':
                            if ($that.is(':checked')) {
                                bypass = false;

                                return false;
                            }

                            bypass = true;
                            break;
                        case 'text':
                            if ($that.val()) {
                                bypass = false;

                                return false;
                            }

                            bypass = true;
                            break;
                    }
                });
            }

            return bypass;
        },
        toggleShowIfCheckedElements: function() {
            var that = this;
            that.$el.find('[data-checked-show]').each(function() {
                var target = $(this).data('checked-show'),
                    checked = $(this).is(':checked'),
                    $target;
                $target = $(target);
                if (checked) {
                    $target.removeClass('hide');
                } else {
                    $target.addClass('hide');
                }
            });
        },
        saveScrollPosition: function() {
            $.cookie('scrollposition', $(window).scrollTop());
        },
        loadScrollPosition: function() {
            var scrollPosition = $.cookie('scrollposition');
            if (scrollPosition) {
                $(window).scrollTop(scrollPosition);
                $.removeCookie('scrollposition');
            }
        },
        toggleRowDeleted: function($row) {
            var deleteState = $row.hasClass('delete'),
                $field = $row.find('.field-delete-row');
            if (deleteState) {
                $row.removeClass('delete');
                $field.val(0);
            } else {
                $row.addClass('delete');
                $field.val(1);
            }
            $(window).trigger('form-row-deleted');
        }
    };
    $.fn.form = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('form');
            if (!data) {
                $this.data('form', (data = new Form(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.form.Constructor = Form;

    // Google Captcha size on the mobile
    if (screen.width > 400) {
        $('.g-recaptcha').attr('data-size', 'normal');
    } else {
        $('.g-recaptcha').attr('data-size', 'compact');
    }
})(jQuery);

function expandTextArea(className) {
    var textAreas = document.getElementsByClassName(className);
    Array.prototype.forEach.call(textAreas, function(textArea) {
        textArea.onkeyup = function() {
            this.style.overflow = 'hidden';
            this.style.height = this.scrollHeight + 'px';
        };
    });
}
expandTextArea('field-textarea');
